import _round from 'lodash-es/round';

export function roundTo(nb: number, num: number) {
  var resto = nb % num;
  if (resto <= num / 2) {
    return _round(nb - resto, 1);
  } else {
    return _round(nb + num - resto, 1);
  }
}
